import lodashUniq from 'lodash/fp/uniq';
import safeLocalStorage from 'client/lib/safeLocalStorage';
import { SR_API_ACTION_RENTER_UPDATE_VIEWED_LISTINGS } from 'api/actionTypes';
import { hasRoleAnonymous } from 'common/userRoles';

export default async function updateViewedListings({ state, apiClient }, { viewedListingId }) {
  const currentUser = state.get('currentUser');
  if (hasRoleAnonymous(currentUser.roles)) {
    const viewedListingIdsStr = safeLocalStorage.getItem('viewedListingIds');
    let viewedListingIds = viewedListingIdsStr ? JSON.parse(viewedListingIdsStr) : [];
    viewedListingIds.unshift(viewedListingId);
    viewedListingIds = lodashUniq(viewedListingIds);

    safeLocalStorage.setItem('viewedListingIds', JSON.stringify(viewedListingIds));

    state.push(['listingsMapView', 'viewedListings'], viewedListingId);
    state.commit();
    return;
  }

  await apiClient.postWithState({
    action: SR_API_ACTION_RENTER_UPDATE_VIEWED_LISTINGS,
    state: state,
    payload: {
      viewedListingId: viewedListingId,
    },
    onSuccess() {
      const currentViewedListings = state.get(['listingsMapView', 'viewedListings']);
      if (!currentViewedListings.includes(viewedListingId)) {
        state.push(['listingsMapView', 'viewedListings'], viewedListingId);
      }
    },
  });
}
